import { useEffect } from 'react';
import { Divider } from '@mui/material';
import { Box, Container } from '@mui/system';
import Logo from '~/assets/images/logo/canfleet.svg';

const GetApp = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || '';
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iphone|ipad|ipod/i.test(userAgent);

    if (isAndroid) {
      const appIntentUrl =
        'intent://#Intent;package=com.breadstack.cantec.ecommerce.driver;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.breadstack.cantec.ecommerce.driver;end;';
      window.location.href = appIntentUrl;
    } else if (isIOS) {
      const fallbackUrl =
        'https://apps.apple.com/vn/app/canfleet-driver-app/id6462470159';
      window.location.href = fallbackUrl;
    } else {
      window.location.href = '/';
    }
  }, []);

  return (
    <Container
      maxWidth='md'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100vh',
        overflow: 'hidden',
        pt: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 0.5,
          color: '#fa8c73',
          fontweight: '600',
          fontSize: '32px',
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        <img
          style={{
            cursor: 'pointer',
            height: '20px',
          }}
          alt='Logo'
          src={Logo}
        />
        <span>CanFleet</span>
      </Box>
      <Box
        sx={{
          flex: 1,
          textAlign: 'center',
          py: 2,
        }}
      >
        Redirecting to the app...
      </Box>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
          p: 2,
        }}
      >
        <img src={Logo} alt='logo' />
        <div>© 2025 Breadstack Delivery. All rights reserved.</div>
      </Box>
    </Container>
  );
};

export default GetApp;
